@if(selectedCable().csa().value() > 0) {

<form class="mce-form-section">

    <div class="mce-form-field-group">

        <div>
            <mat-checkbox [formField]="form().hasCPC">External CPC</mat-checkbox>
        </div>

        @if(form().hasCPC().value()) {

        <div>
            <mat-form-field class="w-full">
                <mat-label>cpc material</mat-label>
                <mat-select [formField]="form().conductor">
                    @for (option of cpcConductors(); track option.value) {
                    <mat-option [value]="option.value">{{option.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="w-full">
                <mat-label>csa</mat-label>
                <mat-select [formField]="form().csa">
                    @for (option of csas(); track option.value) {
                    <mat-option [value]="option.value">{{option.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        }




    </div>

</form>

}



